      // Possible filter values.
      const chairSizeValues = ['S/M', 'L', 'XL'];
      const chairFeaturesValues = ['Custom Version', 'Gepolsterte Armlehnen', 'Visko Aufpolsterung', 'Verstellbare Lordosenstütze']; //Add , 'Hohe Gasfeder', 'Aluminium Fusskreuz' for more filters
      const activeFilters = {
        chairSize: new Set(),
        chairFeatures: new Set()
      };

      // Create filter buttons.
      createFilterButtons('chair-size-filters', chairSizeValues, 'chairSize');
      createFilterButtons('chair-features-filters', chairFeaturesValues, 'chairFeatures');

      function createFilterButtons(containerId, values, filterType) {
        const container = document.getElementById(containerId);
        values.forEach(value => {
          const button = document.createElement('button');
          button.classList.add('filter-button');
          button.textContent = value;
          button.onclick = () => toggleFilter(button, filterType, value);
          container.appendChild(button);
        });
      }

      function toggleFilter(button, filterType, value) {
        // Toggle the active state of the filter button.
        button.classList.toggle('active');

        // Add or remove the filter value.
        if (activeFilters[filterType].has(value)) {
          activeFilters[filterType].delete(value);
        } else {
          activeFilters[filterType].add(value);
        }

        // Update the markers based on the current active filters.
        updateMarkers();
      }

      let map;
      let allMarkers = [];
      let openInfoWindow; 

      function initMap() {
        map = new google.maps.Map(document.getElementById('gmap'), {
          center: {lat: 51.1, lng: 9.9},
          zoom: 6,
          scrollwheel: true,
          mapTypeControl: true,
          scaleControl: true,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          zoomControl: true,
          controlSize: 32,
        });

        // Create the search box and link it to the UI element.
        var input = document.getElementById('search-input');
        var searchBox = new google.maps.places.SearchBox(input);

        // Bias the SearchBox results towards current map's viewport.
        map.addListener('bounds_changed', function() {
          searchBox.setBounds(map.getBounds());
});
        // Add a click listener to the map to close any open info windows
        map.addListener('click', function() {
          if (openInfoWindow) {
            openInfoWindow.close();
          }
        });
        
    // Fetch data from Airtable and create markers on the map.
    fetchAirtableDataAndCreateMarkers();

    // Add the search box functionality.
    addSearchBoxFunctionality(map, searchBox);
  }

 function fetchAirtableDataAndCreateMarkers() {
  // Fetch data from the Google Cloud Function
  fetch('https://us-central1-c2capp-360409.cloudfunctions.net/airtableProxy')
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      // Iterate through the records and create markers on the map.
      data.records.forEach(record => {
        const latitude = record.fields.Latitude;
        const longitude = record.fields.Longitude;
        const chairSize = record.fields['Chair Size'];
        const chairFeatures = record.fields['Chair Features'] || [];
        const zipCode = record.fields['ZIP Code'];
        const city = record.fields['City'];
        const chairMaterial = record.fields['Chair Material'];
        const zeitfenster = record.fields['Zeitfenster'] || [];
        const providerToken = record.fields['Provider Token'];

        // Create a marker for each record.
        const marker = new google.maps.Marker({
          position: new google.maps.LatLng(latitude, longitude),
          map: map,
          chairSize: chairSize,
          chairFeatures: chairFeatures
        });

        allMarkers.push(marker);

        // Create info window content.
        const infoWindowContent = `
          <div class="info-window">
            <h4 class="h5">${zipCode} -  ${city}</h4>
            <hr>
            <h6 class="h6">Gr&ouml;ße</h6>
            ${chairSize}
            <br>
            <h6 class="h6">Material</h6>
            ${chairMaterial}
            <br>
            <h6 class="h6">Ausstattung</h6>
            ${chairFeatures.join(', ')}
            <br>
            <h6 class="h6">Bevorzugte Tageszeit</h6>
            ${zeitfenster.join(', ')}<br>
            
            <button class="infowindow-button" onclick="window.open('https://gamechanger-germany.de/pages/gamechanger-probesitzen-jetzt-termin-anfragen?providerToken=${providerToken}','_self')">Jetzt Termin vereinbaren</button>
          </div>
        `;

        const infoWindow = new google.maps.InfoWindow({
          content: infoWindowContent
        });

         // Add a click listener to open the info window when the marker is clicked.
          marker.addListener('click', function() {
            if (openInfoWindow) {
              openInfoWindow.close();
            }
            infoWindow.open(map, marker);
            openInfoWindow = infoWindow; // Update the openInfoWindow
          });
        });

      updateMarkers();
    });
}



  function updateMarkers() {
    allMarkers.forEach(marker => {
      const isVisible = isMarkerVisible(marker);
      marker.setVisible(isVisible);
    });
  }

  function isMarkerVisible(marker) {
    const chairSizeFilters = activeFilters.chairSize;
    const chairFeaturesFilters = activeFilters.chairFeatures;

    if (chairSizeFilters.size > 0 && !chairSizeFilters.has(marker.chairSize)) {
      return false;
    }

    for (const feature of chairFeaturesFilters) {
      if (!marker.chairFeatures.includes(feature)) {
        return false;
      }
    }

    return true;
  }

 function addSearchBoxFunctionality(map, searchBox) {
  // Listen for the event fired when the user selects a prediction and retrieve
  // more details for that place.
  searchBox.addListener('places_changed', function() {
    var places = searchBox.getPlaces();

    if (places.length == 0) {
      return;
    }

    // For each place, get the icon, name, and location.
    var bounds = new google.maps.LatLngBounds();
    places.forEach(function(place) {
      if (!place.geometry) {
        console.log("Returned place contains no geometry");
        return;
      }

      if (place.geometry.viewport) {
        // Only geocodes have viewport.
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });
    map.fitBounds(bounds);
  });
}

  
  // Add an event listener to initialize the map after the window has finished loading.
  window.addEventListener('load', initMap);

